import {mapActions, mapGetters} from 'vuex'

export const userMixin = {
  computed: {
    ...mapGetters({
      'users': 'users/all',
      'user': 'users/user'
    })
  },
  methods: {
    ...mapActions({
      'getUsers': 'users/getUsers',
      'getUser': 'users/getUser',
      'updateUser': 'users/updateUser',
      'deleteUser': 'users/deleteUser',
      'resetUser': 'users/resetUser',
      'addUser': 'users/addUser',
      'uploadLogo': 'users/uploadLogo',
      'deleteLogo': 'users/deleteLogo'
    })
  }
}



// WEBPACK FOOTER //
// ./src/mixins/userMixin.js